import { State } from './models';

export const STORAGE_KEYS = {
  refreshKey: 'ProvidersAuthRefreshKey',
  logoutTime: 'ProvidersAuthLogoutTime',
};

export const ROLES = {
  public: 'public',
  authed: 'authenticated',
};

// Fake state for development only
export const FAKE_STATE: State = {
  isAuthed: true,
  user: {
    id: 1,
    email: 'test@test.com',
    handle: 'tester',
    role: {
      name: 'Authenticated',
      description: 'Default role given to authenticated user.',
      type: ROLES.authed,
    },
  },
};
